import { Grid, Typography } from '@frontierag/frontier-ui-library';

import { styles } from './styles';
import type { IDataAccordionTitle } from './types';

export default function DataAccordionTitle({ text, id = '--', children }: IDataAccordionTitle) {
  return (
    <Grid
      container
      rowSpacing={1}
      columnSpacing={1}
      alignItems="center"
      justifyContent="space-between"
    >
      <Grid container item sm columnSpacing={{ xs: 1, sm: 1.5 }} alignItems="center">
        <Grid
          item
          xs
          sx={{ minWidth: { xs: id ? 69 : 1 }, maxWidth: { sm: id ? 69 : 1 } }}
          flexGrow={id ? 0 : 1}
        >
          {text}
        </Grid>
        {id && (
          <Grid item xs zeroMinWidth>
            <Typography color="primary" variant="inherit" sx={styles.titleId}>
              {id}
            </Typography>
          </Grid>
        )}
      </Grid>

      {children}
    </Grid>
  );
}
